import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";
import TableLoader from "../../../components/Common/TableLoader";

function Table(props) {
  const { data } = props;

  // Calculate totals for each column
  const totals = data.reduce(
    (acc, curr) => {
      acc.no_of_bets += curr.no_of_bets;
      acc.total_sales += curr.total_sales;
      acc.payout += curr.payout;
      acc["win/loss"] += curr["win/loss"];
      acc.wht += curr.wht;
      acc.betting_tax += curr.betting_tax;
      acc.excise_tax += curr.excise_tax;
      acc.GGR += curr.GGR;
      acc.NGR += curr.NGR;
      return acc;
    },
    {
      no_of_bets: 0,
      total_sales: 0,
      payout: 0,
      "win/loss": 0,
      wht: 0,
      betting_tax: 0,
      excise_tax: 0,
      GGR: 0,
      NGR:0,
    }
  );

  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
      footer: "Total:",
    },
    {
      dataField: "no_of_bets",
      text: "No of bets",
      sort: true,
      footer: totals.no_of_bets.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(parseFloat(row.no_of_bets ?? 0)?.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "total_sales",
      text: "Total Sales",
      sort: true,
      footer: totals.total_sales.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.total_sales.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "payout",
      text: "Payouts",
      sort: true,
      footer: totals.payout.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.payout.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "win/loss",
      text: "Win/Loss",
      sort: true,
      footer: totals["win/loss"].toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.win_loss.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "wht",
      text: "With holding Tax",
      sort: true,
      footer: totals.wht.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(parseFloat(row.wht).toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "betting_tax",
      text: "Betting Tax",
      sort: true,
      footer: totals.betting_tax.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.betting_tax.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "excise_tax",
      text: "Excise",
      sort: true,
      footer: totals.excise_tax.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(parseFloat(row.excise_tax).toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "GGR",
      text: "GGR",
      sort: true,
      footer: totals.GGR.toLocaleString("en-GB"),
      formatter: (cell, row) => (
        <>{Number(row.GGR.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "NGR",
      text: "NGR",
      sort: true,
      footer: totals.NGR.toLocaleString("en-GB"),
      formatter: (cell, row) => (
        <>{Number(row.NGR.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
  ];

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ];

  const { SearchBar } = Search;
  //pagination customization

  const pageOptions = {
    sizePerPage: data.length,
    totalSize: data.length,
    custom: true,
  };

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Board Report"}</div>
          {props.loadingMessage && props.loadingMessage === "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {(toolkitProps) => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Board-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              classes={"table align-middle table-nowrap table-check"}
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  );
}

export default Table;
